import { auroraComponentStyles } from './auroraComponentStyles'
import { ComponentStyles } from './componentStyles'

export const bendComponentStyles: ComponentStyles = {
  ...auroraComponentStyles,
  primaryButton: {
    ...auroraComponentStyles.primaryButton,
    borderWidth: 2,
  },
}
